import {STYLES} from "../configs/styles";


const STYLE_INJECTION_MIXIN = {
    computed: {
        styles: () => STYLES
    },
};

export {
    STYLE_INJECTION_MIXIN
}